import React from "react";

import { RecordItem } from "types/common";
const columnVariants: { [key: string]: string } = {
  default: "border-transparent bg-[#18181b] text-white shadow ",
  secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
  destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
  outline: "text-foreground"
};

const badgeVariants = {
  better: "bg-[#017848] text-white border-transparent",
  default: "border-primary-600 bg-transparent text-primary-600",
  secondary: "border-transparent bg-[#ebebeb] text-primary-700 ",
  destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
  outline: "text-foreground"
};

export type BadgeVariant = "default" | "secondary" | "destructive" | "outline" | "better";

const getBadgeVariantStyles = (variant = "default", className?: string, isFromColumns?: boolean) => {
  const base =
    "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ";
  const finalVariants: RecordItem = isFromColumns ? columnVariants : badgeVariants;
  return base + finalVariants[variant] + " " + className;
};

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: BadgeVariant;
  isFromColumns?: boolean;
}

function Badge({ className, variant, isFromColumns, ...props }: BadgeProps) {
  return <div className={getBadgeVariantStyles(variant, className, isFromColumns)} {...props} />;
}

export { Badge, badgeVariants };
